import'./index.css';
export default function Title({text, className}) {
  return (
    <h1 className={`title ${className || ''}`}>
      {text.toLowerCase()}
    </h1>
  );

}